import type {RouteRecordRaw} from 'vue-router';
import BaseCompany from '@/components/company/index.vue';
import type {CommonRouteMeta} from '@/types/common';

const invoiceRoutes: RouteRecordRaw[] = [
    {
        path: '/invoice',
        component: BaseCompany,
        meta: {
            hidden: true,
            noCache: false,
            requiresAuth: false,
            middleware: ['companyStore'],
            layout: 'Default',
        } as CommonRouteMeta,
        children: [
            {
                path: ':token',
                component: () => import('@/views/invoice/PublicInvoiceView.vue'),
                name: 'public.invoice',
                meta: {title: 'Invoice', noCache: false} as CommonRouteMeta,
            },
        ],
    },
];

export default invoiceRoutes;
